export const isElementTop = el => el && !el.scrollTop
